import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { PMC8266EventMotionDetection } from '@EcamModel/model/PMC8266EventMotionDetection';
import { PMC8266ParkingSpaceDetection } from '@EcamModel/model/PMC8266ParkingSpaceDetection';
import { PMC8266RecordSetting } from '@EcamModel/model/PMC8266RecordSetting';
import { PMC8266StorageSetting } from '@EcamModel/model/PMC8266StorageSetting';
import { PMC8266SysDateTime } from '@EcamModel/model/PMC8266SysDateTime';
import { PMC8266SysInfo } from '@EcamModel/model/PMC8266SysInfo';
import { PMC8266SnapshotSetting } from '@EcamModel/model/PMC826SnapshotSetting';
import { AxiosInstance } from 'axios';
import {
    IPMC8266CamConfigureRequestHttpController,
    ISendActionGet,
} from '../IPMC8266CamConfigureRequestHttpController';

export class PMC8266CamConfigureRequestHttpController
    extends BaseHttpController<any>
    implements IPMC8266CamConfigureRequestHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'pmc8266-cam-configure-request', client);
    }

    async getPhotoSnapshot(props: ISendActionGet): Promise<string> {
        return await this.doPost({ path: 'get-photo-snapshot', body: props }).then((res) => res.data);
    }

    async getPMC8266StorageSetting(props: ISendActionGet): Promise<PMC8266StorageSetting> {
        return await this.doPost({ path: 'get-pmc8266-storage-setting', body: props }).then((res) => res.data);
    }

    async getPMC8266EventMotionDetection(props: ISendActionGet): Promise<PMC8266EventMotionDetection> {
        return await this.doPost({ path: 'get-pmc8266-event-motion-detection', body: props }).then((res) => res.data);
    }

    async getPMC8266RecordSetting(props: ISendActionGet): Promise<PMC8266RecordSetting> {
        return await this.doPost({ path: 'get-pmc8266-record-setting', body: props }).then((res) => res.data);
    }

    async getPMC8266SysDateTime(props: ISendActionGet): Promise<PMC8266SysDateTime> {
        return await this.doPost({ path: 'get-pmc8266-sys-date-time', body: props }).then((res) => res.data);
    }

    async getPMC8266SnapShotSetting(props: ISendActionGet): Promise<PMC8266SnapshotSetting> {
        return await this.doPost({ path: 'get-pmc8266-snapshot-setting', body: props }).then((res) => res.data);
    }

    async getPMC8266SystemInfo(props: ISendActionGet): Promise<PMC8266SysInfo> {
        return await this.doPost({ path: 'get-pmc8266-sys-info', body: props }).then((res) => res.data);
    }

    async getPMC8266ParkingSpaceDetection(props: ISendActionGet): Promise<PMC8266ParkingSpaceDetection> {
        return await this.doPost({ path: 'get-pmc8266-parking-space-detection', body: props }).then((res) => res.data);
    }
}
